import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyTanieProdukty() {
  return <ArticleLayout article={articlesBySlug['kakobuy-tanie-produkty-pod-100-pln']} />;
}